import { handleGender } from '../../core/services/utils/helpers';
import { Gender } from '../../core/types/enums';
import { JsonProperty } from '../../core/services/utils/mapping.service';

export enum PartnerSyncStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
  FAILED = 'FAILED',
  WARNING = 'WARNING',
}
export interface CorePartnerDepartmentDto {
  externalId: number;
  departmentName: string;
}

export class CorePartnerResidentAccountsDto {
  id: number = 0;
  label: string = '';
}
export class CorePartnerResidentDto {
  firstName: string = '';
  lastName: string = '';
  gender: string = '';
  externalId: number = 0;
  roomNumber: number = 0;
  @JsonProperty({ clazz: CorePartnerResidentAccountsDto, name: 'accounts' })
  accounts: CorePartnerResidentAccountsDto[] = [];

  getName(): string {
    let name = `${this.firstName} ${this.lastName}`;

    return `${handleGender(this.gender as Gender)} ${name}`;
  }
}

export interface CorePartnerResidentAccountDto {
  firstName: string;
  lastName: string;
  gender: string;
  externalId: number;
  residentId: number;
  roomNumber: string;
  accounts: CorePartnerResidentAccountsDto[];
}

export interface PartnerSyncData {
  failReason: string;
  syncDate: string;
  status: PartnerSyncStatus;
  residents: CorePartnerResidentAccountDto[];
  initialPartnerMappingCompleted?: boolean;
}

export interface Connection {
  externalId: number;
  departmentId: number;
  departmentName: string;
  iconUrl: string;
  wasDepartmentSync: boolean;
}

/** Mirrors core's PartnerSyncResidentMappingSettings. */
export interface PartnerSyncResidentMappingSettings {
  residentId: number | null;
  accountId: number | null;
}

/**
 * Partner-sync mapping bodies are keyed by the partner's external id, which is
 * a numeric string for Connext and a FHIR UUID for MediFox — core types both as
 * Map<String, …>.
 */
export type PartnerSyncMapping<T> = { [externalId: string]: T };

export interface MedifoxCredentials {
  tenantId: string;
  tenantKey: string;
}
